export default {
    USER_MASTER: 'master',
    USER_ADMIN: 'admin',
    USER_MANAGER: 'manager',
    USER_REGULAR: 'regular',
}